// TrainingPanel.js — FTL sekmesi > TRAINING (DUTY HISTORY ile SKPK arasi)
//
// Serkan (17 Agu 2026): "Egitimleri ve egitim tarihi ve expire tarihi girmek
//  icin TRAINING modul ekleyelim, her 3 pilot icin giris yapma imkani olsun,
//  +ADD TRN ile ekleyelim. 60 gun kala, 30 gun kala, 15 gun kala alarm."
//
// ┌ UC AYRI ISLEM — KARISTIRILMAZ ─────────────────────────────────────────┐
// │ ADD    yeni kayit                                                       │
// │ RENEW  YENI OLAY -> YENI SATIR; eskisi 'superseded', tarihi DEGISMEZ.   │
// │        Sebep denetim: "12 Mart'ta uctugunda OPC'si gecerli miydi?"      │
// │ EDIT   AYNI OLAY, yanlis yazilmis -> satir YERINDE duzeltilir.          │
// │        Serkan: "biz egitimin gerekliligini delete etmiyoruz, sadece     │
// │        icini edit edebilelim; matbu bir hata olabilir, tarihler,        │
// │        isimler, harf hatasi olabilir. Edit edilebilsin her sey."        │
// │        + "rapor yazilsin tabi" -> GEREKCE ZORUNLU ve iz DEGISIKLIKTEN   │
// │        ONCE yazilir (ftl_duty_edits deseninin ayinisi).                 │
// └────────────────────────────────────────────────────────────────────────┘
//
// SILME = ISARETLEME (13 Eki 2026, saha — Serkan: *"edit var ama delete yok; delete olsun, tabii reason girilmek
// zorunda"*). pilot_trainings'te DELETE policy YOK ve olmayacak (hard delete YASAK, Ilke 4): DELETE kaydi 'deleted'
// yapar — gerekce zorunlu (veritabani da reddeder), iz once yazilir, kayit hicbir hesaba girmez (`silinmisMi`), SHOW
// HISTORY'de DELETED olarak durur, geri acilmaz (tetik). Eski karar ("delete etmiyoruz, yalniz edit") boylece degisti.
// TRAINING LIST (13 Eki 2026): sirketin egitim listesi — ekle / sirket egitimini duzelt / cikar (kullanimdaysa emekliye).
//
// DIGER KARARLAR (spec: GO2EFB/FTL-LIMITS-TRAINING-SPEC.md, bolum B):
//  · Suresi dolmus egitim gorev atamasini ENGELLEMEZ, UYARIR.
//  · GIRILMEMIS veri uyari URETMEZ ("veri girilince uyari sistemi kurulur").
//  · BELGE YUKLEME YOK (KVKK) — tutulan tek sey tarih ve yenileme suresi.
//  · Dogum tarihi YALNIZ medical kaydinda, sistemde baska hicbir yerde yok.
//
// Hesap TrainingRules.js'te (saf mantik). Bu dosya ekran + kayit.
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import GosterGizle from './GosterGizle';
import { supabase } from '../supabaseClient';
// 🔑 ŞİRKETİN yerel günü (21 Eyl 2026, Serkan: *"ana üs yereli"*).
import { useSirketDilimi, dilimUyarisi } from './sirketDilimi';   // uyarı metni tek kaynak (14 Eki 2026: okunamadı ≠ yok)
import {
  computeExpiry, trainingStatus, medicalValidityMonths, ageAt,
  STATE_COLOR, ALERT_DAYS, todayLocal, latestPerTraining, previousRecord, silinmisMi, durumMetni,
} from './TrainingRules';
// Serbest metin girisleri BUYUK HARF — TEK KAYNAK `up` (iOS: TextFormat.swift).
// Kendi buyuk-harf mantigimizi yazmayiz; Turkce karakter donusumu de burada.
import LocationPicker from './LocationPicker';
import { locationEksigi } from './DutyLocationRules';
import { useDutyLocations } from './useDutyLocations';

import HarfliGiris from './HarfliGiris';
import { GerekcePenceresi as OrtakGerekcePenceresi, GerekceIpucu, gerekceTamam, gerekceIpucuMetni } from './gerekce';   // tek gerekçe penceresi + kural (21 Eki 2026, K7)
import { zAlan } from './tasarim';   // zorunlu alan rengi — iPad kuralı, kaydetme kapısının koşuluyla (5 Eki 2026)
import { bildirimleriTazele } from './bildirimOlayi';
import { ucusEkibindenMi } from '../roller';
import { vh } from '../yaziBoyutu';
import { usePencereKapat, KapatX } from './pencereKapat';   // pencere kapatma tek tip — ESC + ✕ (12 Eki 2026)
import { dugmeStili } from './tasarim';
import Katlanir from './Katlanir';
import { SAYILI, hepsiniOku, okumaDenetimi } from './kesikOkuma';   // 24 ay şartı — parça parça, düşen/kesik okuma söylenir (6 Eki 2026)
import OkumaHatasi from './OkumaHatasi';
const C = {
  bg2:'var(--bg2)', bg3:'var(--bg3)', border:'var(--border)', border2:'var(--border2)',
  accent:'var(--accent)', green:'var(--green)', red:'var(--red)', amber:'var(--amber)',
  t1:'var(--t1)', t2:'var(--t2)', t3:'var(--t3)',
};
const S = {
  panel:{ background:C.bg2, border:`1px solid ${C.border}`, borderRadius:10, overflow:'hidden', marginBottom:22 },
  panelH:{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'11px 16px', borderBottom:`1px solid ${C.border}`, background:C.bg3 },
  panelT:{ fontSize:11, fontWeight:700, letterSpacing:2, color:C.accent, textTransform:'uppercase', fontFamily:'var(--mono)' },
  table:{ width:'100%', borderCollapse:'collapse' },
  th:{ padding:'9px 12px', textAlign:'left', fontSize:10, color:C.t1, fontWeight:700, letterSpacing:1, textTransform:'uppercase', borderBottom:`1px solid ${C.border}`, background:C.bg3, whiteSpace:'nowrap', fontFamily:'var(--mono)' },
  td:{ padding:'8px 12px', borderBottom:`1px solid ${C.border}`, color:C.t1, fontSize:12.5, fontWeight:600, verticalAlign:'middle', whiteSpace:'nowrap', fontFamily:'var(--mono)', fontVariantNumeric:'tabular-nums' },
  label:{ fontSize:10, color:C.t2, fontWeight:700, letterSpacing:1.5, textTransform:'uppercase', fontFamily:'var(--mono)', display:'block', marginBottom:6 },
  input:{ background:'var(--input-bg)', border:`1px solid ${C.border}`, borderRadius:6, color:C.t1, padding:'9px 11px', fontSize:13, fontFamily:'var(--mono)', width:'100%', boxSizing:'border-box', outline:'none' },
  // 1 Eki 2026 — düğmeler ORTAK tasarımdan (tasarim.js, Serkan: "her modülün içinde butonlarda border, aynı tasarım"); eskiden bu dosyada ayrı tanımlıydı.
  btnP:dugmeStili('birincil'),
  btnS:dugmeStili('notr'),
  btnTiny:{ background:'none', color:C.t3, border:`1px solid ${C.border2}`, borderRadius:5, padding:'2px 9px', fontSize:9, fontFamily:'var(--mono)', cursor:'pointer', letterSpacing:1 },
  note:{ fontSize:10, color:C.t3, letterSpacing:.5, lineHeight:1.7, padding:'9px 12px', background:C.bg3, borderLeft:`2px solid ${C.border2}`, fontFamily:'var(--mono)' },
  modalBg:{ position:'fixed', inset:0, background:'var(--backdrop)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:60, padding:20 },
  modal:{ background:C.bg2, border:`1px solid ${C.border2}`, borderRadius:12, width:540, maxWidth:'100%', maxHeight:vh(90), overflowY:'auto', boxShadow:'var(--shadow)' },
};
// "Bugun" TrainingRules.todayLocal()'dan gelir — kendi kopyamizi yazmayiz.
// Eskiden burada da canda da ayri birer toISOString() kopyasi vardi (UTC) ve
// Turkiye'de gece 00:00-03:00 arasi gun bir geride kaliyordu.

const stateBadge = (state, daysLeft) => {
  const c = STATE_COLOR[state] || C.t3;
  const txt = durumMetni(state, daysLeft);
  return (
    <span style={{ display:'inline-block', padding:'2px 8px', fontSize:9, letterSpacing:1,
                   fontWeight:700, border:`1px solid ${c}`, color:c, fontFamily:'var(--mono)' }}>
      {txt}
    </span>
  );
};

/** Pilot bloğunun başlığındaki durum özeti — yalnız GEÇERLİ kayıtlar (eskiler uyarı üretmez). Kademe renkleri
 *  STATE_COLOR'dan (tek kaynak); uyarı yoksa yeşil ALL VALID; hiç kayıt yoksa boş. */
const OZET_SIRASI = ['EXPIRED', 'CRITICAL', 'WARNING', 'NOTICE'];
function pilotOzeti(gecerliler, bugun) {
  if (!gecerliler.length) return null;
  const say = {};
  gecerliler.forEach(r => { const s = trainingStatus(r.expires_at, bugun).state; say[s] = (say[s] || 0) + 1; });
  const rozet = (renk, metin, k) => (
    <span key={k} data-testid={`trn-ozet-${k}`} style={{ display:'inline-block', padding:'1px 7px', fontSize:9, letterSpacing:1, fontWeight:700,
                                       border:`1px solid ${renk}`, color:renk, fontFamily:'var(--mono)' }}>{metin}</span>);
  const uyarilar = OZET_SIRASI.filter(s => say[s]).map(s =>
    rozet(STATE_COLOR[s], s === 'EXPIRED' ? `${say[s]} EXPIRED` : `${say[s]} ≤${ALERT_DAYS[s]} D`, s));
  return uyarilar.length ? uyarilar : rozet(STATE_COLOR.VALID, 'ALL VALID', 'VALID');
}

const basisText = (rule, anchor) =>
    rule === 'CARRY_FORWARD' ? `carried from ${anchor}`
  : rule === 'END_OF_MONTH'  ? 'from end of check month'
  : rule === 'NO_EXPIRY'     ? 'no re-assessment required'
  : 'from check date';

export default function TrainingPanel({ toast, myProfile, pilots, customerId, readOnly = false }) {
  // Sehir listesi FTL yer gorevi formuyla AYNI kancadan (Ilke 3).
  const { locations, okumaHatasi: konumHatasi, addLocation, reloadLocations } = useDutyLocations(customerId);
  const [catalog, setCatalog] = useState([]);
  const [rows, setRows] = useState([]);
  const [changes, setChanges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showHistory, setShowHistory] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [modal, setModal] = useState(null);   // {mode:'add'|'edit', row?} | null
  const [silinecek, setSilinecek] = useState(null);   // DELETE gerekçe penceresi — kayıt
  const [listeAcik, setListeAcik] = useState(false);  // TRAINING LIST penceresi
  // 🔑 PİLOT BAŞINA KATLANIR (1 Eki 2026, Serkan: "training modülünün içini de rule set gibi collapse yap, çok uzun
  //    görünüyor"). Varsayılan KAPALI (RULE SET gibi, "basınca açılsın"); başlıkta durum özeti — kapalı blok uyarıyı
  //    GİZLEMEZ (İlke 1).
  const [acik, setAcik] = useState({});

  const [lisansDob, setLisansDob] = useState({});   // ATPL & MED'den okunur
  // 🔴 6 Eki 2026 (24 ay şartı, 2c-2) — Serkan: *"yarım yamalak veri olmaz"* (A). Dört okumanın hiçbirinin `error`ü
  //    okunmuyordu: eğitim kayıtları düşerse ekran "kayıt yok" gibi görünüyor, katalog düşerse "NO TRAINING CATALOG …
  //    run migration" diyordu (okunamayan katalog, olmayan katalog değildir). Eğitim kayıtları tek istekte okunduğu için
  //    sunucu sınırında da kesilebiliyordu. Şimdi kayıtlar PARÇA PARÇA, dört okuma da `okumaDenetimi`nden; biri düşer ya
  //    da sayıları tutmazsa ekran HİÇ gösterilmez, öteki ekranlardaki kutu (OkumaHatasi) okumayı adıyla söyler.
  const [okumaHatasi, setOkumaHatasi] = useState(null);
  const load = useCallback(async () => {
    setLoading(true);
    const [catS, trnS, chS, plmS] = await Promise.all([
      supabase.from('training_catalog').select('*', SAYILI).eq('customer_id', customerId).order('sort_order'),
      hepsiniOku(() => supabase.from('pilot_trainings').select('*', SAYILI).eq('customer_id', customerId).order('completed_date', { ascending: false })),
      // CHANGE REPORT (6 Eki 2026, 2d-2): koda gömülü son 200 kalktı — kayıt listesi tam, parça parça (Serkan).
      hepsiniOku(() => supabase.from('training_changes').select('*', SAYILI).eq('customer_id', customerId).order('changed_at', { ascending: false })),
      // 🔑 DOĞUM TARİHİNİN SAHİBİ ARTIK ATPL & MED (5 Eyl 2026, Serkan onayı).
      //    Eskiden her eğitim satırı kendi `date_of_birth`ini taşıyordu: aynı
      //    kişinin iki kaydında farklı tarih olabiliyor, FCL.065 uygulanamıyor,
      //    MED'in 6/12 ay hesabı o satır girilmeden çalışmıyordu.
      //    *"Veri tek yerde, her şeyi besler."*
      supabase.from('pilot_licence_med').select('pilot_id,date_of_birth,created_at', SAYILI)
        .eq('customer_id', customerId).order('created_at', { ascending: false }),
    ]);
    const { dustu, oku } = okumaDenetimi();
    const cat = oku('TRAINING CATALOG (training_catalog)', catS), trn = oku('TRAINING RECORDS (pilot_trainings)', trnS),
          ch = oku('CHANGE REPORT (training_changes)', chS), plm = oku('DATES OF BIRTH (pilot_licence_med)', plmS);
    if (dustu.length) { setOkumaHatasi(dustu); setLoading(false); return; }
    setOkumaHatasi(null);
    const dogum = {};
    (plm || []).forEach(r => { if (!dogum[r.pilot_id] && r.date_of_birth) dogum[r.pilot_id] = r.date_of_birth; });
    setLisansDob(dogum);
    setCatalog(cat || []); setRows(trn || []); setChanges(ch || []);
    setLoading(false);
  }, [customerId]);
  useEffect(() => { if (customerId) load(); }, [load, customerId]);

  const crew = useMemo(() => (pilots || []).filter(ucusEkibindenMi), [pilots]);
  const catByCode = useMemo(() => Object.fromEntries(catalog.map(c => [c.code, c])), [catalog]);
  const pilotName = useCallback(
    (id) => { const p = crew.find(x => x.id === id); return p ? (p.code ? p.code + ' — ' : '') + (p.full_name || '') : '—'; },
    [crew]);
  // KRONOLOJIK KURAL (Serkan, 19 Agu): hangi kaydin gecerli oldugunu `status`
  // damgasi degil TARIH soyler. Damga giris sirasina gore yaziliyordu ve eski
  // tarihli bir kaydin ikinci kez girilmesi daha yeni bir kaydi sessizce devre
  // disi birakabiliyordu (AAK/LC, 19 Agu canli veri). Butun kayitlar listede
  // DURUR — "girili butun kayitlar duracak sistemde, ama uyari esigi en
  // guncele gore".
  //
  // ⚠️ BU HOOK ASAGIDAKI ERKEN RETURN'LERDEN ONCE DURMAK ZORUNDA. Ilk surumde
  //    `visible`in yanina, return'lerin ALTINA konmustu: loading=true iken hic
  //    calismiyor, veri gelince calisiyordu -> React "hook sayisi degisti" deyip
  //    bileseni cokertiyor ve TRAINING sekmesi HIC ACILMIYORDU (19 Agu).
  const gecerliIds = useMemo(
    () => new Set(latestPerTraining(rows).map(r => r.id)), [rows]);
  // Silinmemiş kayıtlar — kayıt penceresinin devir/önceki kayıt hesabı bunlardan (silinen kayıt hiçbir hesaba girmez).
  const canliKayitlar = useMemo(() => rows.filter(r => !silinmisMi(r)), [rows]);

  // Geçerlilik günü ŞİRKETİN ana üs yerelinde okunur — eğitim nerede alınırsa
  // alınsın. Ana üs çözülemezse cihazın yereline düşer ve bunu EKRANDA söyler.
  const dilim = useSirketDilimi();
  const t = todayLocal(dilim.tz);

  if (loading) return <div style={{ padding:24, color:C.t3, fontSize:11, fontFamily:'var(--mono)' }}>LOADING TRAINING DATA...</div>;

  // Yarım veri yok (Serkan A) — katalog denetiminden ÖNCE: okunamayan katalog "NO TRAINING CATALOG" diye okunmaz.
  // Görev yerleri (şehir listesi) ayrı kancadan; düşerse aynı kutuya katılır (21 Eki 2026, W4).
  if (okumaHatasi || konumHatasi) return (
    <OkumaHatasi testid="egitim-okuma-hatasi" style={{ padding:24 }} satirlar={[...(okumaHatasi || []), ...(konumHatasi || [])]}
      onRetry={() => { if (okumaHatasi) load(); if (konumHatasi) reloadLocations(); }}
      baslik="TRAINING COULD NOT BE LOADED — the records are not shown with partial data." />
  );

  // Katalog yoksa SESSIZ KALMAYIZ: bos ekran "kayit yok" diye okunurdu, oysa
  // goc kosulmamis olabilir (Ilke 1).
  if (catalog.length === 0) {
    return (
      <div style={{ padding:24, color:C.red, fontSize:11, fontFamily:'var(--mono)', lineHeight:1.9 }}>
        NO TRAINING CATALOG FOR THIS CUSTOMER<br />
        <span style={{ color:C.t3 }}>run supabase/migrations/20260817_training_module.sql</span>
      </div>
    );
  }

  const visible = rows.filter(r => showHistory || gecerliIds.has(r.id));

  // ── DELETE (13 Eki 2026) — İZ ÖNCE, sonra işaret. Kayıt geçerli olandıysa (status current) aynı eğitimin kalan en yeni
  //    kaydı damgayı alır (hesap zaten tarihe bakar; damga veritabanında tutarlı kalsın — tek 'current' indeksi).
  const silKayit = async (r, gerekce) => {
    const { error: izErr } = await supabase.from('training_changes').insert({
      customer_id: customerId, training_id: r.id, action: 'TRN_DELETE', field: 'status',
      old_value: r.status, new_value: 'deleted', reason: gerekce, changed_by: myProfile?.id || null,
    });
    if (izErr) { toast?.('AUDIT WRITE FAILED, NOTHING DELETED — ' + izErr.message, 'error'); return false; }
    const { data: yaz, error } = await supabase.from('pilot_trainings')
      .update({ status: 'deleted', delete_reason: gerekce, deleted_by: myProfile?.id || null,
                deleted_at: new Date().toISOString(), updated_at: new Date().toISOString() })
      .eq('id', r.id).select('id');
    if (error) { toast?.('DELETE FAILED — ' + error.message, 'error'); return false; }
    // RLS'in sessiz reddi hata döndürmez, 0 satır döndürür (İlke 2).
    if (!yaz || !yaz.length) { toast?.('DELETE NOT WRITTEN — the server changed no record. Nothing was deleted.', 'error'); return false; }
    let uyari = '';
    if (r.status === 'current') {
      const kalan = latestPerTraining(rows.filter(x => x.id !== r.id && x.pilot_id === r.pilot_id
                                                     && x.training_code === r.training_code))[0];
      if (kalan && kalan.status !== 'current') {
        const { error: dErr } = await supabase.from('pilot_trainings')
          .update({ status: 'current', updated_at: new Date().toISOString() }).eq('id', kalan.id);
        if (dErr) uyari = ' · PREVIOUS RECORD NOT RE-MARKED CURRENT (validity follows the date, alerts are right)';
      }
    }
    toast?.(`TRAINING RECORD DELETED — ${r.training_code} ${r.completed_date}, kept in history${uyari}`);
    load(); bildirimleriTazele();
    return true;
  };

  return (
    <>
      {dilimUyarisi(dilim) && (
        /* 🔴 SESSİZ DÜŞÜŞ YOK (İlke 1): ana üs çözülemediğinde tarihler cihazın
           yerelinde gösterilir ve bu EKRANDA YAZAR. Aksi hâlde "bugün"ün neye göre
           ölçüldüğü bakan kişiye bağlı kalırdı. */
        <div data-testid="dilim-yok"
             style={{ background:'rgba(224,160,32,0.12)', border:'1px solid var(--orange)',
                      borderRadius:6, padding:'7px 11px', margin:'0 0 10px',
                      fontSize:11, color:'var(--orange)', fontFamily:'var(--mono)' }}>
          {dilimUyarisi(dilim)}
        </div>)}
      <div style={S.panel}>
        <div style={S.panelH}>
          <span style={S.panelT}>Training — validity &amp; renewals</span>
          <div style={{ display:'flex', gap:10, alignItems:'center' }}>
            {/* Göster/gizle — tek bileşen (5 Eki 2026, Serkan tasarım B). */}
            <GosterGizle acik={showReport} onClick={() => setShowReport(v => !v)}
                         gizle="HIDE REPORT" goster="CHANGE REPORT" testid="training-report-toggle" />
            <GosterGizle acik={showHistory} onClick={() => setShowHistory(h => !h)}
                         gizle="HIDE HISTORY" goster="SHOW HISTORY" testid="training-history-toggle" />
            <button style={S.btnP} data-testid="egitim-listesi-ac" onClick={() => setListeAcik(true)}>TRAINING LIST</button>
            {!readOnly && (
              <button style={S.btnP} onClick={() => setModal({ mode:'add' })}>+ ADD TRN</button>
            )}
          </div>
        </div>

        {crew.map(p => {
          const mine = visible.filter(r => r.pilot_id === p.id);
          const ad = (p.code ? p.code + ' — ' : '') + (p.full_name || '').toUpperCase();
          return (
            <Katlanir key={p.id} baslik={ad} sayi={mine.length} birim={['record', 'records']}
                      testId={`trn-pilot-${p.code || p.id}`} acikMi={!!acik[p.id]}
                      onToggle={() => setAcik(a => ({ ...a, [p.id]: !a[p.id] }))}
                      ek={pilotOzeti(mine.filter(r => gecerliIds.has(r.id)), t)}>
              {mine.length === 0 ? (
                // GIRILMEMIS VERI UYARI URETMEZ (Serkan). Bos satir "kayit yok" der; MISSING/eksik rozeti YAZILMAZ.
                <div style={{ ...S.td, color:C.t3 }}>no training recorded</div>
              ) : (
                <table style={S.table}>
                  <thead>
                    <tr>
                      <th style={S.th}>Training</th>
                      <th style={S.th}>Val</th>
                      <th style={S.th}>Completed</th>
                      <th style={S.th}>Expires</th>
                      <th style={S.th}>Status</th>
                      <th style={S.th}>Issued by</th>
                      <th style={S.th}>Basis</th>
                      <th style={S.th} />
                    </tr>
                  </thead>
                  <tbody>
                    {mine.map(r => {
                      const cat = catByCode[r.training_code];
                      const st = trainingStatus(r.expires_at, t);
                      const sil = silinmisMi(r);
                      const sup = !gecerliIds.has(r.id);   // gecerli DEGIL (tarihe gore) — silinen de
                      return (
                        <tr key={r.id} style={sup ? { opacity: sil ? .6 : .5 } : undefined} data-testid={`trn-satir-${r.id}`}>
                          <td style={S.td}>
                            <span style={sil ? { textDecoration:'line-through' } : undefined}>{r.training_code}</span>
                            {sil
                              ? <span style={{ marginLeft:8, fontSize:9, color:C.red }} data-testid={`trn-silindi-${r.id}`}>DELETED</span>
                              : sup && <span style={{ marginLeft:8, fontSize:9, color:C.t3 }}>SUPERSEDED</span>}
                          </td>
                          <td style={{ ...S.td, color:C.t2 }}>{r.validity_months != null ? `${r.validity_months}M` : '—'}</td>
                          <td style={S.td}>{r.completed_date}</td>
                          <td style={S.td}>{r.expires_at || (cat?.no_expiry ? 'NO EXPIRY' : '—')}</td>
                          <td style={S.td}>{sil
                            ? <span style={{ fontSize:9, color:C.red, whiteSpace:'normal' }}>
                                {String(r.deleted_at || '').slice(0, 10)} — {r.delete_reason || '—'}
                              </span>
                            : (sup ? '' : stateBadge(st.state, st.daysLeft))}</td>
                          <td style={{ ...S.td, color:C.t2, whiteSpace:'normal' }}>{r.issued_by || '—'}</td>
                          {/* Her tarih HANGI MADDEDEN ciktigini yaninda tasir. */}
                          <td style={{ ...S.td, color:C.t3, fontSize:9.5, whiteSpace:'normal', maxWidth:250 }}>
                            {basisText(r.applied_rule, r.anchor_date)}
                            {cat?.legal_reference && <><br /><span style={{ color:C.t2 }}>{cat.legal_reference}</span></>}
                          </td>
                          <td style={S.td}>
                            {!readOnly && !sil && (
                              <span style={{ display:'inline-flex', gap:6 }}>
                                <button style={S.btnTiny} onClick={() => setModal({ mode:'edit', row:r })}>EDIT</button>
                                <button style={{ ...S.btnTiny, color:C.red, borderColor:C.red }} data-testid={`trn-sil-${r.id}`}
                                        onClick={() => setSilinecek(r)}>DELETE</button>
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </Katlanir>
          );
        })}

        <div style={S.note}>
          BASIS: SHT-OPS EK-3 · ORO.FC.230 (g)(h) &nbsp;·&nbsp; AMC1 ORO.FC.230(b)(4) &nbsp;·&nbsp;
          SHT-FCL FCL.740 / FCL.055 &nbsp;·&nbsp; SHT-MED MED.A.045<br />
          Alerts are fixed at {ALERT_DAYS.NOTICE} / {ALERT_DAYS.WARNING} / {ALERT_DAYS.CRITICAL} days
          and count down on the local calendar day. Validity always follows the record with the
          <b> latest completion date</b> — every record is kept, but only the newest one drives the alert.<br />
          An expired training does <b>not</b> block duty assignment — it raises a warning only.
          Trainings with no record produce no warning. A typo is corrected with EDIT (reason required,
          logged), a new event creates a new row and supersedes the previous one. DELETE (reason required,
          logged) takes a record out of every calculation — the previous record counts again — but the record
          is not erased: SHOW HISTORY lists it as DELETED with its date and reason.
        </div>
      </div>

      {showReport && (
        <div style={S.panel}>
          <div style={S.panelH}><span style={S.panelT}>Change report</span></div>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>When</th><th style={S.th}>Action</th><th style={S.th}>Field</th>
                <th style={S.th}>Old</th><th style={S.th}>New</th><th style={S.th}>Reason</th>
              </tr>
            </thead>
            <tbody>
              {changes.length === 0 && (
                <tr><td style={{ ...S.td, color:C.t3 }} colSpan={6}>no changes recorded</td></tr>
              )}
              {changes.map(c => (
                <tr key={c.id}>
                  <td style={S.td}>{(c.changed_at || '').slice(0, 16).replace('T', ' ')}</td>
                  <td style={S.td}>{c.action}</td>
                  <td style={{ ...S.td, color:C.t2 }}>{c.field || '—'}</td>
                  <td style={{ ...S.td, color:C.t3 }}>{c.old_value || '—'}</td>
                  <td style={S.td}>{c.new_value || '—'}</td>
                  <td style={{ ...S.td, color:C.t2, whiteSpace:'normal' }}>{c.reason || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {modal && (
        <TrainingModal
          locations={locations} addLocation={addLocation}
          {...{ toast, myProfile, customerId, crew, catalog, pilotName }}
          rows={canliKayitlar}
          mode={modal.mode}
          row={modal.row || null}
          onClose={() => setModal(null)}
          // Kayıt olunca zil de hemen okur (29 Eyl 2026, Serkan: "sayacın doğru
          // çalışması için sayfa yenilemek gerekti").
          onSaved={() => { setModal(null); load(); bildirimleriTazele(); }}
          lisansDob={lisansDob}
        />
      )}

      {silinecek && (
        <GerekcePenceresi
          baslik={`DELETE TRAINING RECORD — ${pilotName(silinecek.pilot_id)}`}
          aciklama={`${silinecek.training_code} · completed ${silinecek.completed_date}${silinecek.expires_at ? ` · expires ${silinecek.expires_at}` : ''}. `
            + 'The record is taken out of every calculation (the previous record of this training counts again) but it is not '
            + 'erased: SHOW HISTORY keeps it as DELETED with this reason. It cannot be undone.'}
          onayMetni="DELETE RECORD" testid="trn-sil"
          onClose={() => setSilinecek(null)}
          onOnay={async (g) => { if (await silKayit(silinecek, g)) setSilinecek(null); }} />
      )}

      {listeAcik && (
        <EgitimListesi {...{ toast, myProfile, customerId, catalog, readOnly }} kayitlar={rows}
                       onClose={() => setListeAcik(false)} onDegisti={load} />
      )}
    </>
  );
}

// ── TRAINING LIST (13 Eki 2026, saha — Serkan: *"master eğitim listesine ekleme yapmak istiyorlar — bu listeye ilave
//    yap, çıkar onu da"* · *"ana ekrana ADD TRAINING'in soluna TRAINING LIST butonu ekle"* · *"ona basınca bütün liste
//    çıksın, altında da ADD NEW TRAINING olsun"*). Kararlar: mevzuattan gelen eğitim (REGULATION) KİLİTLİ · şirketin
//    eklediği (CUSTOM) düzeltilebilir, KODU DEĞİŞMEZ (kayıtlar koda bağlı) · REMOVE: kaydı yoksa listeden kalkar, varsa
//    EMEKLİYE ayrılır (yeni girişte seçilmez, kayıtları ve geçmişi durur) · her işlem gerekçeli ve izli (training_changes:
//    CATALOG_ADD / CATALOG_EDIT / CATALOG_DELETE / CATALOG_RETIRE). Kilitler veritabanında da var (göç 20261013a).
const BASLANGIC = [['CHECK_DATE', 'CHECK DATE'], ['END_OF_MONTH', 'END OF CHECK MONTH'], ['NO_EXPIRY', 'NO EXPIRY']];
const katSure = (c) => (c.no_expiry ? 'NO EXPIRY' : c.default_validity_months != null ? `${c.default_validity_months}M` : '—');
const katBaslangic = (c) => (c.no_expiry ? '—' : c.anchor_rule === 'END_OF_MONTH' ? 'END OF MONTH' : 'CHECK DATE');

function EgitimListesi({ toast, myProfile, customerId, catalog, kayitlar, readOnly, onClose, onDegisti }) {
  const [form, setForm] = useState(null);         // null | { duzenlenen: catalog satırı | null }
  const [cikarilacak, setCikarilacak] = useState(null);
  usePencereKapat(onClose);
  const kullanim = (code) => (kayitlar || []).filter(r => r.training_code === code).length;

  const cikar = async (c, gerekce) => {
    const n = kullanim(c.code);
    const emekli = n > 0;
    const { error: izErr } = await supabase.from('training_changes').insert({
      customer_id: customerId, catalog_id: c.id, action: emekli ? 'CATALOG_RETIRE' : 'CATALOG_DELETE',
      field: emekli ? 'active' : 'code', old_value: emekli ? 'true' : c.code, new_value: emekli ? 'false' : null,
      reason: gerekce, changed_by: myProfile?.id || null,
    });
    if (izErr) { toast?.('AUDIT WRITE FAILED, NOTHING CHANGED — ' + izErr.message, 'error'); return false; }
    const q = emekli
      ? supabase.from('training_catalog').update({ active: false, updated_at: new Date().toISOString() }).eq('id', c.id).select('id')
      : supabase.from('training_catalog').delete().eq('id', c.id).select('id');
    const { data, error } = await q;
    if (error) { toast?.('NOT REMOVED — ' + error.message, 'error'); return false; }
    if (!data || !data.length) { toast?.('NOT REMOVED — the server changed nothing.', 'error'); return false; }
    toast?.(emekli ? `${c.code} RETIRED — ${n} record(s) keep it; it can no longer be chosen for a new entry`
                   : `${c.code} REMOVED FROM THE LIST`);
    onDegisti();
    return true;
  };

  return (
    <div style={{ ...S.modalBg, alignItems:'flex-start', overflowY:'auto' }}>
      <div style={{ ...S.modal, width:880, maxHeight:'none', margin:'24px 0' }} data-testid="egitim-listesi">
        <div style={S.panelH}>
          <span style={S.panelT}>Training list — {catalog.length} trainings</span>
          <KapatX onClose={onClose} testid="egitim-listesi-x" />
        </div>
        <div style={{ overflowX:'auto' }}>
          <table style={S.table}>
            <thead><tr>{['Code', 'Name', 'Val', 'Starts', 'Basis', 'Source', ''].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
            <tbody>
              {catalog.map(c => {
                const sirket = c.source !== 'REGULATION';
                const emekli = c.active === false;
                return (
                  <tr key={c.id || c.code} data-testid={`katalog-${c.code}`} style={emekli ? { opacity:.5 } : undefined}>
                    <td style={S.td}>{c.code}</td>
                    <td style={{ ...S.td, whiteSpace:'normal' }}>{c.name}</td>
                    <td style={{ ...S.td, color:C.t2 }}>{katSure(c)}</td>
                    <td style={{ ...S.td, color:C.t2 }}>{katBaslangic(c)}</td>
                    <td style={{ ...S.td, color:C.t3, fontSize:9.5, whiteSpace:'normal', maxWidth:200 }}>{c.legal_reference || '—'}</td>
                    <td style={S.td}>
                      <span style={{ fontSize:9, letterSpacing:1, padding:'1px 6px', border:`1px solid ${sirket ? C.green : C.accent}`,
                                     color: sirket ? C.green : C.accent }}>{sirket ? 'COMPANY' : 'REGULATION'}</span>
                    </td>
                    <td style={S.td}>
                      {!sirket ? <span style={{ fontSize:9, color:C.t3 }} data-testid={`katalog-kilitli-${c.code}`}>LOCKED</span>
                        : emekli ? <span style={{ fontSize:9, color:C.t3 }}>RETIRED</span>
                        : !readOnly && (
                          <span style={{ display:'inline-flex', gap:6 }}>
                            <button style={S.btnTiny} data-testid={`katalog-duzelt-${c.code}`}
                                    onClick={() => setForm({ duzenlenen: c })}>EDIT</button>
                            <button style={{ ...S.btnTiny, color:C.red, borderColor:C.red }} data-testid={`katalog-cikar-${c.code}`}
                                    onClick={() => setCikarilacak(c)}>REMOVE</button>
                          </span>
                        )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div style={{ padding:16, display:'grid', gap:12 }}>
          {!readOnly && !form && (
            <button style={{ ...S.btnP, borderStyle:'dashed', width:'100%' }} data-testid="egitim-ekle-ac"
                    onClick={() => setForm({ duzenlenen: null })}>+ ADD NEW TRAINING</button>
          )}
          {form && (
            <EgitimFormu key={form.duzenlenen?.code || 'yeni'} {...{ toast, myProfile, customerId, catalog }}
                         duzenlenen={form.duzenlenen} onVazgec={() => setForm(null)}
                         onKaydedildi={() => { setForm(null); onDegisti(); }} />
          )}
          <div style={{ ...S.note }}>
            REGULATION trainings come from the regulation and are locked. A COMPANY training can be corrected (its code
            cannot change — records are linked by code) or removed: with no records it leaves the list, with records it is
            RETIRED — it can no longer be chosen for a new entry, and its records and history stay. Every change needs a
            reason and is listed in CHANGE REPORT. Alerts are the same 60 / 30 / 15 days for every training.
          </div>
          <div style={{ display:'flex', justifyContent:'flex-end' }}>
            <button style={S.btnS} onClick={onClose} data-testid="egitim-listesi-kapat">CLOSE</button>
          </div>
        </div>
      </div>
      {cikarilacak && (
        <GerekcePenceresi
          baslik={`REMOVE ${cikarilacak.code} FROM THE TRAINING LIST`}
          aciklama={kullanim(cikarilacak.code)
            ? `${cikarilacak.code} has ${kullanim(cikarilacak.code)} record(s), so it is RETIRED, not deleted: it can no longer be chosen `
              + 'for a new entry; its records, their validity and the history stay.'
            : `${cikarilacak.code} has no records — it leaves the list.`}
          onayMetni={kullanim(cikarilacak.code) ? 'RETIRE' : 'REMOVE'} testid="katalog-cikar"
          onClose={() => setCikarilacak(null)}
          onOnay={async (g) => { if (await cikar(cikarilacak, g)) setCikarilacak(null); }} />
      )}
    </div>
  );
}

// Ekleme ve düzeltme AYNI form (tek kalıp). Düzeltmede KOD kilitli.
function EgitimFormu({ toast, myProfile, customerId, catalog, duzenlenen, onVazgec, onKaydedildi }) {
  const d = duzenlenen;
  const [kod, setKod] = useState(d?.code || '');
  const [ad, setAd] = useState(d?.name || '');
  const [baslangic, setBaslangic] = useState(d ? (d.no_expiry ? 'NO_EXPIRY' : d.anchor_rule || 'CHECK_DATE') : 'CHECK_DATE');
  const [ay, setAy] = useState(d?.default_validity_months != null ? String(d.default_validity_months) : '');
  const [dayanak, setDayanak] = useState(d?.legal_reference || '');
  const [gerekce, setGerekce] = useState('');
  const [mesgul, setMesgul] = useState(false);
  const suresiz = baslangic === 'NO_EXPIRY';
  const ayGecerli = suresiz || (/^\d+$/.test(ay) && Number(ay) > 0);
  const kodTemiz = kod.trim().toUpperCase();
  const kopya = !d && catalog.some(c => c.code === kodTemiz);
  const eksik = [!kodTemiz && 'CODE', !ad.trim() && 'NAME', !ayGecerli && 'VALIDITY (MO)', !gerekceTamam(gerekce) && 'REASON']
    .filter(Boolean);

  const kaydet = async () => {
    if (eksik.length) { toast?.(`REQUIRED — ${eksik.join(' · ')}`, 'error'); return; }
    if (kopya) { toast?.(`${kodTemiz} IS ALREADY IN THE LIST`, 'error'); return; }
    const alanlar = {
      name: ad.trim(), no_expiry: suresiz, anchor_rule: suresiz ? 'CHECK_DATE' : baslangic,
      default_validity_months: suresiz ? null : Number(ay), legal_reference: dayanak.trim() || null,
    };
    setMesgul(true);
    try {
      if (d) {
        // DÜZELTME — iz ÖNCE, alan alan (TRN_CORRECT deseni).
        const eski = (k) => (k === 'no_expiry' ? !!d[k] : d[k]);   // boolean: boş = false (yanlış fark izi yazılmasın)
        const farklar = Object.entries(alanlar).filter(([k, v]) => String(eski(k) ?? '') !== String(v ?? ''))
          .map(([k, v]) => ({ customer_id: customerId, catalog_id: d.id, action: 'CATALOG_EDIT', field: k,
                              old_value: eski(k) == null ? null : String(eski(k)), new_value: v == null ? null : String(v),
                              reason: gerekce.trim(), changed_by: myProfile?.id || null }));
        if (!farklar.length) { toast?.('NO CHANGE'); return; }
        const { error: izErr } = await supabase.from('training_changes').insert(farklar);
        if (izErr) { toast?.('AUDIT WRITE FAILED, NOTHING CHANGED — ' + izErr.message, 'error'); return; }
        const { data, error } = await supabase.from('training_catalog')
          .update({ ...alanlar, updated_at: new Date().toISOString() }).eq('id', d.id).select('id');
        if (error) { toast?.('NOT SAVED — ' + error.message, 'error'); return; }
        if (!data || !data.length) { toast?.('NOT SAVED — the server changed nothing.', 'error'); return; }
        toast?.(`${d.code} CORRECTED — ${farklar.length} FIELD(S) LOGGED`);
        onKaydedildi();
        return;
      }
      // EKLEME — satır doğmadan kimliği yok: önce eklenir, iz hemen ardından (TRN_ADD deseni); iz düşerse SÖYLENİR.
      const sira = Math.max(0, ...catalog.map(c => c.sort_order || 0)) + 10;
      const { data: ins, error } = await supabase.from('training_catalog')
        .insert({ ...alanlar, customer_id: customerId, code: kodTemiz, source: 'CUSTOM', mandatory: false,
                  active: true, sort_order: sira })
        .select('id').single();
      if (error) { toast?.('NOT ADDED — ' + error.message, 'error'); return; }
      const { error: izErr } = await supabase.from('training_changes').insert({
        customer_id: customerId, catalog_id: ins.id, action: 'CATALOG_ADD', field: 'code', old_value: null,
        new_value: kodTemiz, reason: gerekce.trim(), changed_by: myProfile?.id || null,
      });
      toast?.(`${kodTemiz} ADDED TO THE TRAINING LIST${izErr ? ' · AUDIT NOT WRITTEN' : ''}`, izErr ? 'error' : undefined);
      onKaydedildi();
    } finally { setMesgul(false); }
  };

  return (
    <div style={{ border:`1.5px dashed ${C.accent}`, borderRadius:8, padding:14, display:'grid', gap:12 }} data-testid="egitim-formu">
      <span style={S.panelT}>{d ? `Correct ${d.code}` : 'Add new training'}</span>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 2fr 1fr', gap:10 }}>
        <div><span style={S.label}>Code *</span>
          <HarfliGiris {...zAlan(S.input, !d, !!kodTemiz && !kopya)} data-testid="egitim-kod" value={kod} disabled={!!d}
                       onChange={setKod} placeholder="E.G. DGR_REC" />
          {kopya && <div style={{ fontSize:9, color:C.red, marginTop:3 }}>ALREADY IN THE LIST</div>}
        </div>
        <div><span style={S.label}>Name *</span>
          <HarfliGiris {...zAlan(S.input, true, !!ad.trim())} data-testid="egitim-ad" value={ad} onChange={setAd}
                       placeholder="E.G. DANGEROUS GOODS RECURRENT" />
        </div>
        <div><span style={S.label}>Validity (mo) *</span>
          <HarfliGiris {...zAlan(S.input, !suresiz, ayGecerli)} data-testid="egitim-sure" value={suresiz ? '' : ay}
                       disabled={suresiz} onChange={v => setAy(String(v).replace(/[^0-9]/g, ''))} />
        </div>
      </div>
      <div><span style={S.label}>Validity starts</span>
        <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
          {BASLANGIC.map(([k, etiket]) => (
            <button key={k} type="button" data-testid={`egitim-baslangic-${k}`}
                    style={{ ...S.btnS, ...(baslangic === k ? { borderColor:C.accent, color:C.accent } : {}) }}
                    onClick={() => setBaslangic(k)}>{etiket}</button>
          ))}
        </div>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
        <div><span style={S.label}>Basis (optional)</span>
          <HarfliGiris style={S.input} data-testid="egitim-dayanak" value={dayanak} onChange={setDayanak}
                       placeholder="E.G. COMPANY OM-D 2.3" />
        </div>
        <div><span style={S.label}>Reason *</span>
          <HarfliGiris {...zAlan(S.input, true, gerekceTamam(gerekce))} data-testid="egitim-liste-gerekce" value={gerekce}
                       onChange={setGerekce} placeholder="E.G. NEW COMPANY REQUIREMENT" />
          <GerekceIpucu metin={gerekce} testid="egitim-liste-gerekce-ipucu" />
        </div>
      </div>
      <div style={{ display:'flex', justifyContent:'flex-end', gap:10 }}>
        <button style={S.btnS} onClick={onVazgec} disabled={mesgul}>CANCEL</button>
        <button style={{ ...S.btnP, opacity: eksik.length || kopya || mesgul ? .45 : 1 }} disabled={!!eksik.length || kopya || mesgul}
                data-testid="egitim-liste-kaydet" onClick={kaydet}>
          {mesgul ? 'SAVING...' : d ? 'SAVE CORRECTION' : 'ADD TO LIST'}
        </button>
      </div>
    </div>
  );
}

// ── GEREKÇE PENCERESİ (13 Eki 2026) — DELETE ve TRAINING LIST işlemleri: gerekçe ZORUNLU, veritabanı da aynı sınırla
//    reddeder. 21 Eki 2026 (K7, Serkan tasarım A): pencere ve kural ortak (`gerekce.js`) — burada yalnız TRAINING'in hâli
//    (kırmızı açıklama + kırmızı onay, katman 80, örnek metin). Çağıranların prop'ları aynı (baslik, aciklama, onayMetni …).
const GerekcePenceresi = (p) => (
  <OrtakGerekcePenceresi aciklamaTur="silme" onayTur="silme" zIndex={80} ornek="E.G. ENTERED TWICE BY MISTAKE" {...p} />
);

// ═══════════════════════════════════════════════════════════════════
// ADD / RENEW / EDIT — tek modal, mod'a gore davranis
// ═══════════════════════════════════════════════════════════════════
function TrainingModal({ toast, myProfile, customerId, crew, catalog, rows, pilotName,
                         mode, row, onClose, onSaved, locations = [], addLocation,
                         lisansDob = {} }) {
  const editing = mode === 'edit';
  // Formun "bugün"ü de şirketin günü olmalı — panel bir gün, form başka gün
  // gösterseydi kayıt gün sınırında yanlış tarihle açılırdı.
  const dilimM = useSirketDilimi();

  const [pilotId, setPilotId]   = useState(row?.pilot_id || crew[0]?.id || '');
  const [code, setCode]         = useState(row?.training_code || catalog.find(c => c.active !== false)?.code || '');
  const [completed, setCompleted] = useState(row?.completed_date || todayLocal(dilimM.tz));
  const [months, setMonths]     = useState(row?.validity_months != null ? String(row.validity_months) : '');
  const [issuedBy, setIssuedBy] = useState(row?.issued_by || '');
  const [dob, setDob]           = useState(row?.date_of_birth || '');
  const [notes, setNotes]       = useState(row?.notes || '');
  const [reason, setReason]     = useState('');
  const [saving, setSaving]     = useState(false);
  usePencereKapat(saving ? null : onClose);
  // LOCATION (1 Eyl 2026) — Serkan: *"Egitimlerin location'i bilinir; egitim
  // planlanmissa yeri de bellidir, location secilmeli."* Sertifikada yazan
  // tarih, egitimin YAPILDIGI YERIN yerel gunudur; yeri kayitta durmazsa
  // "bu tarih neden bir gun farkli" sorusu cevapsiz kalir.
  const [loc, setLoc] = useState({ location: row?.location || '', location_tz: row?.location_tz || null });
  const locEksik = locationEksigi('training', { location: loc.location, locationTz: loc.location_tz });

  const cat = useMemo(() => catalog.find(c => c.code === code) || null, [catalog, code]);

  // Ayni pilot+kod icin GIRILEN TARIHTEN ONCEKI kayit — devir capasi budur.
  // Eskiden `status==='current'` satiri aranirdi; damga giris sirasina gore
  // yazildigi icin geriye donuk bir kayit girildiginde YANLIS capa secilirdi.
  // Simdi tarihten bulunur ve `superseded_by` baglantisina HIC bakilmaz —
  // o baglanti kopsa bile hesap dogru kalir (19 Agu acik bulgusu kapandi).
  const prev = useMemo(
    () => previousRecord(rows, { pilotId, code, completed, excludeId: row?.id || null }),
    [rows, pilotId, code, completed, row]);

  // Ayni kalemin BUTUN kayitlari (kendisi haric) — geriye donuk giris tespiti.
  const grup = useMemo(
    () => rows.filter(r => r.pilot_id === pilotId && r.training_code === code && r.id !== row?.id),
    [rows, pilotId, code, row]);

  // Girilen tarih grubun en yenisi mi? Degilse bu kayit UYARIYI BELIRLEMEZ —
  // ama sistemde durur (Serkan: "girili butun kayitlar duracak sistemde").
  const dahaYeniVar = useMemo(
    () => grup.find(r => (r.completed_date || '') > (completed || '')) || null,
    [grup, completed]);

  // 🔑 DOĞUM TARİHİ ÖNCE ATPL & MED'DEN (5 Eyl 2026, Serkan onayı):
  //    *"Veri tek yerde, her şeyi besler."*  Orada yoksa eski kayıttan
  //    düşülür — mevcut veriyi kırmamak için — ama ekranda hangi kaynaktan
  //    geldiği YAZAR, yoksa hangi tarihe göre hesaplandığı görünmez (İlke 1).
  const modulDob = lisansDob[pilotId] || '';
  const eskiKayitDob = useMemo(
    () => rows.find(r => r.pilot_id === pilotId && r.training_code === code && r.date_of_birth && r.id !== row?.id)?.date_of_birth || '',
    [rows, pilotId, code, row]);
  const prevDob = modulDob || eskiKayitDob;
  const dobKaynak = modulDob ? 'ATPL & MED' : (eskiKayitDob ? 'previous training record' : null);
  useEffect(() => { if (!editing) setDob(prevDob); }, [prevDob, editing]);

  // Katalog degisince varsayilan sure (admin ustune yazabilir).
  useEffect(() => {
    if (!cat || editing) return;
    setMonths(cat.default_validity_months != null ? String(cat.default_validity_months) : '');
  }, [cat, editing]);

  // MED: sure DOGUM TARIHINDEN — MED.A.045(a)(2); yas MUAYENE tarihindeki yas
  // (a)(5)(i). Dogum tarihi yoksa HESAPLANMAZ (uydurma yok).
  const autoMonths = useMemo(
    () => (cat?.age_dependent ? medicalValidityMonths(dob, completed) : null),
    [cat, dob, completed]);
  useEffect(() => { if (autoMonths != null) setMonths(String(autoMonths)); }, [autoMonths]);

  const calc = useMemo(() => computeExpiry({
    completed,
    validityMonths: months === '' ? null : Number(months),
    cat,
    prevExpiry: prev?.expires_at || null,
  }), [completed, months, cat, prev]);

  const dobWarn = cat?.age_dependent && dob && prevDob && dob !== prevDob;

  // ── RESET (13 Eki 2026, Serkan: *"burada bir de reset tuşu olsun, girişler komple sıfırlansın, ekranda tek tek
  //    silmesin"*). Pencere AÇILDIĞI hâline döner: ADD'de varsayılanlar (ilk pilot, ilk eğitim, bugün, kataloğun süresi),
  //    EDIT'te kaydın kendi değerleri. Doğum tarihi ve MED süresi aynı kurallarla yeniden gelir (yukarıdaki efektler).
  const sifirla = () => {
    const ilkPilot = row?.pilot_id || crew[0]?.id || '';
    const ilkKod = row?.training_code || catalog.find(c => c.active !== false)?.code || '';
    const ilkCat = catalog.find(c => c.code === ilkKod) || null;
    setPilotId(ilkPilot);
    setCode(ilkKod);
    setCompleted(row?.completed_date || todayLocal(dilimM.tz));
    setMonths(editing ? (row?.validity_months != null ? String(row.validity_months) : '')
      : (ilkCat?.default_validity_months != null ? String(ilkCat.default_validity_months) : ''));
    setIssuedBy(row?.issued_by || '');
    setNotes(row?.notes || '');
    setReason('');
    setLoc({ location: row?.location || '', location_tz: row?.location_tz || null });
    // Aynı pilot + eğitimde efekt yeniden çalışmaz — doğum tarihi burada geri konur; değiştiyse efekt getirir.
    setDob(editing ? (row?.date_of_birth || '') : (ilkPilot === pilotId && ilkKod === code ? prevDob : ''));
  };

  const save = async () => {
    if (!pilotId || !code || !completed) { toast?.('PILOT, TRAINING AND DATE REQUIRED'); return; }
    if (!cat?.no_expiry && months === '')  { toast?.('VALIDITY REQUIRED'); return; }
    // GEREKCE ZORUNLU (ftl_duty_edits deseni). Bir kaydin ustune yaziliyorsa
    // NEDEN yazildigi da durmali; gerekcesiz duzeltme denetimde savunulamaz.
    if (editing && !gerekceTamam(reason)) { toast?.(gerekceIpucuMetni(reason)); return; }
    setSaving(true);

    // alert_days ARTIK YAZILMAZ: esik 60/30/15 sabittir ve TrainingRules'ta
    // tek yerde durur (Serkan, 19 Agu: "ayni kalsin, degismesin"). Kolon semada
    // kalir, eski kayitlarin degeri silinmez (Ilke 4) — sadece okunmaz.
    const fields = {
      pilot_id: pilotId,
      training_code: code,
      completed_date: completed,
      validity_months: months === '' ? null : Number(months),
      expires_at: calc.expiresAt,
      applied_rule: calc.appliedRule,
      anchor_date: calc.anchorDate,
      issued_by: issuedBy || null,
      date_of_birth: cat?.age_dependent ? (dob || null) : null,
      notes: notes || null,
      location: loc.location || null,
      location_tz: loc.location_tz || null,
    };

    // ───────────── EDIT: yerinde duzeltme ─────────────
    if (editing) {
      // IZ DEGISIKLIKTEN ONCE YAZILIR — update duserse bile neyin denendigi
      // kayitli kalir (ftl_duty_edits ile ayni sira).
      const diffs = Object.entries(fields)
        .filter(([k, v]) => String(row[k] ?? '') !== String(v ?? ''))
        .map(([k, v]) => ({
          customer_id: customerId, training_id: row.id, action: 'TRN_CORRECT',
          field: k, old_value: row[k] == null ? null : String(row[k]),
          new_value: v == null ? null : String(v),
          reason: reason.trim(), changed_by: myProfile?.id || null,
        }));

      if (diffs.length === 0) { setSaving(false); toast?.('NO CHANGE'); return; }
      const { error: logErr } = await supabase.from('training_changes').insert(diffs);
      if (logErr) { setSaving(false); toast?.('AUDIT WRITE FAILED — ' + logErr.message); return; }

      const { error } = await supabase.from('pilot_trainings')
        .update({ ...fields, updated_at: new Date().toISOString() })
        .eq('id', row.id);
      setSaving(false);
      if (error) { toast?.('UPDATE FAILED — ' + error.message); return; }
      toast?.(`CORRECTED — ${diffs.length} FIELD(S) LOGGED`);
      onSaved();
      return;
    }

    // ───────────── ADD / RENEW: yeni satir ─────────────
    // KRONOLOJIK KURAL: yeni kayit 'current' damgasini ANCAK grubun en yeni
    // tarihlisiyse alir. Geriye donuk bir giris yururlukteki kaydi DEVIRMEZ
    // — eskiden deviriyordu ve AAK/LC boyle bozulmustu (19 Agu).
    // Not: hesap zaten damgaya degil tarihe bakiyor; damga veritabani
    // seviyesinde tutarli kalsin diye dogru yaziliyor (kismi unique index
    // ayni anda iki 'current' satira izin vermez).
    const mevcutCurrent = grup.find(r => r.status === 'current') || null;
    const gecerliOlacak = !dahaYeniVar;
    let uyari = '';

    // Yeni kayit gecerli olacaksa, damgayi tasiyan satiri ONCE dusurmeliyiz.
    // Insert duserse GERI ALIRIZ — yarim durumda birakmayiz (Ilke 2).
    if (gecerliOlacak && mevcutCurrent) {
      const { error } = await supabase.from('pilot_trainings')
        .update({ status:'superseded', updated_at:new Date().toISOString() }).eq('id', mevcutCurrent.id);
      if (error) { setSaving(false); toast?.('SUPERSEDE FAILED — ' + error.message); return; }
    }

    const { data: ins, error } = await supabase.from('pilot_trainings')
      .insert({ ...fields, customer_id: customerId,
                status: gecerliOlacak ? 'current' : 'superseded',
                superseded_by: gecerliOlacak ? null : (dahaYeniVar?.id || null),
                created_by: myProfile?.id || null })
      .select('id').single();

    if (error) {
      if (gecerliOlacak && mevcutCurrent) {
        await supabase.from('pilot_trainings').update({ status:'current' }).eq('id', mevcutCurrent.id);
      }
      setSaving(false); toast?.('SAVE FAILED — ' + error.message); return;
    }

    // superseded_by yalnizca IZ'dir; hesap ona BAKMAZ (capa tarihten bulunur).
    // Yine de duserse SESSIZ KALMAYIZ (Ilke 2) — eskiden bu satirin sonucu hic
    // okunmuyordu.
    if (gecerliOlacak && mevcutCurrent) {
      const { error: linkErr } = await supabase.from('pilot_trainings')
        .update({ superseded_by: ins.id }).eq('id', mevcutCurrent.id);
      if (linkErr) uyari = ' · LINK NOT WRITTEN';
    }

    // Denetim izi de kontrolsuz yazilmayacak: iz dusmusse kullanici bilmeli,
    // cunku kayit izsiz kalmis olur (Ilke 4).
    const { error: izErr } = await supabase.from('training_changes').insert({
      customer_id: customerId, training_id: ins.id,
      action: prev ? 'TRN_RENEW' : 'TRN_ADD',
      field: 'expires_at',
      old_value: prev?.expires_at || null,
      new_value: calc.expiresAt,
      reason: reason.trim() || calc.appliedRule,
      changed_by: myProfile?.id || null,
    });
    if (izErr) uyari += ' · AUDIT NOT WRITTEN';

    setSaving(false);
    toast?.((gecerliOlacak ? (prev ? 'TRAINING RENEWED' : 'TRAINING ADDED')
                          : 'RECORD ADDED — NOT THE LATEST, ALERTS UNCHANGED') + uyari);
    onSaved();
  };

  const title = editing ? 'Correct training record' : (prev ? 'Renew training' : 'Add training');

  return (
    <div style={S.modalBg} onClick={onClose}>
      <div style={S.modal} onClick={e => e.stopPropagation()}>
        <div style={S.panelH}>
          <span style={S.panelT}>{title}</span>
          <KapatX onClose={onClose} disabled={saving} />
        </div>

        <div style={{ padding:18, display:'grid', gap:14 }}>
          {editing && (
            <div style={{ ...S.note, borderLeftColor:C.accent }}>
              CORRECTION — this fixes a mistyped entry on the SAME record.
              If the training was actually taken again, close this and use <b>+ ADD TRN</b>:
              a new event must create a new row, not overwrite this one.
            </div>
          )}

          <div>
            <label style={S.label}>Pilot</label>
            <select {...zAlan(S.input, true, !!pilotId)} data-testid="egitim-pilot" value={pilotId} onChange={e => setPilotId(e.target.value)}>
              {crew.map(p => <option key={p.id} value={p.id}>{(p.code ? p.code + ' — ' : '') + (p.full_name || '')}</option>)}
            </select>
          </div>

          <div>
            <label style={S.label}>Training</label>
            <select {...zAlan(S.input, true, !!code)} data-testid="egitim-tur" value={code} onChange={e => setCode(e.target.value)}>
              {catalog.filter(c => c.active || c.code === code).map(c => (
                <option key={c.code} value={c.code}>{c.code} — {c.name}</option>
              ))}
            </select>
            {cat?.legal_reference && (
              <div style={{ marginTop:5, fontSize:9.5, color:C.t3, fontFamily:'var(--mono)' }}>
                {cat.source === 'REGULATION' && <span style={{ color:C.amber, marginRight:6 }}>MANDATORY</span>}
                {cat.legal_reference}
              </div>
            )}
          </div>

          {!editing && prev && !dahaYeniVar && (
            <div style={{ ...S.note, borderLeftColor:C.amber }}>
              RENEWAL — previous record expires <b>{prev.expires_at || '—'}</b> and will be marked
              SUPERSEDED. Its dates are not modified.
            </div>
          )}

          {/* GERIYE DONUK GIRIS — sistem susmaz (Ilke 1). Kayit kabul edilir ve
              listede durur, ama uyari esigini BELIRLEMEZ; belirleyen en yeni
              tarihli kayittir (Serkan, 19 Agu). Eskiden bu giris yururlukteki
              kaydi SESSIZCE devirirdi. */}
          {dahaYeniVar && (
            <div style={{ ...S.note, borderLeftColor:C.red, color:C.t1 }}>
              NOT THE LATEST RECORD — a newer {code} exists for this pilot
              (completed <b>{dahaYeniVar.completed_date}</b>, expires <b>{dahaYeniVar.expires_at || '—'}</b>).
              <br />This entry will be kept in the history, but the alert will continue to follow the
              newer record. Nothing is overwritten.
            </div>
          )}

          <div style={{ display:'grid', gridTemplateColumns:'1fr 130px', gap:12 }}>
            <div>
              <label style={S.label}>Completed</label>
              <input {...zAlan(S.input, true, !!completed)} data-testid="egitim-tarih" type="date" value={completed} onChange={e => setCompleted(e.target.value)} />
            </div>
            <div>
              <label style={S.label}>Validity (mo)</label>
              <HarfliGiris {...zAlan(S.input, !cat?.no_expiry, months !== '')} data-testid="egitim-ay" value={months} disabled={!!cat?.no_expiry}
                     onChange={v => setMonths(v.replace(/[^0-9]/g, ''))} />
            </div>
          </div>

          {/* DOGUM TARIHI — YALNIZ yasa bagli kalemde (medical). Sistemde baska
              hicbir yerde tutulmaz (Serkan, KVKK). */}
          {cat?.age_dependent && (
            <div>
              <label style={S.label}>Date of birth <span style={{ color:C.t3 }}>— medical only</span></label>
              <input style={S.input} type="date" value={dob} onChange={e => setDob(e.target.value)} />
              <div style={{ marginTop:5, fontSize:9.5, color:C.t3, fontFamily:'var(--mono)', lineHeight:1.7 }}>
                {dob
                  ? <>age at examination <b>{ageAt(dob, completed)}</b> → validity <b>{autoMonths} months</b> · MED.A.045(a)(2),(a)(5)(i)</>
                  : <>enter date of birth to derive validity (12 / 6 months) — MED.A.045(a)(2)</>}
                {dobWarn && <div style={{ color:C.amber }}>⚠ differs from previous record ({prevDob})</div>}
                {dobKaynak && (
                  <div style={{ color: modulDob ? C.t3 : C.amber, fontSize:10, marginTop:2 }}>
                    {modulDob
                      ? 'Date of birth comes from ATPL & MED — one source for every rule.'
                      : 'Not recorded in ATPL & MED yet — taken from a previous training record. '
                        + 'Enter it there so FCL.065 and the OML rule can use it too.'}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Hesaplanan bitis + HANGI MADDEDEN ciktigi */}
          <div style={{ background:C.bg3, border:`1px solid ${C.border}`, borderRadius:8, padding:'12px 14px' }}>
            <div style={{ fontSize:10, letterSpacing:1.5, color:C.t2, fontFamily:'var(--mono)', marginBottom:5 }}>EXPIRES</div>
            <div style={{ fontSize:18, fontWeight:700, fontFamily:'var(--mono)',
                          color:(calc.expiresAt || cat?.no_expiry) ? C.t1 : C.red }}>
              {cat?.no_expiry ? 'NO EXPIRY' : (calc.expiresAt || 'INTERVAL NOT SET')}
            </div>
            <div style={{ marginTop:5, fontSize:9.5, color:C.t3, fontFamily:'var(--mono)', lineHeight:1.6 }}>
              ⓘ {calc.note}
            </div>
            {editing && row.expires_at && row.expires_at !== calc.expiresAt && (
              <div style={{ marginTop:6, fontSize:9.5, color:C.amber, fontFamily:'var(--mono)' }}>
                was {row.expires_at} → {calc.expiresAt || '—'}
              </div>
            )}
          </div>

          {/* LOCATION — Serkan (1 Eyl): "egitimlerin location'i bilinir,
              egitim planlanmissa yeri de bellidir, location secilmeli."
              Sertifikadaki tarih egitimin YAPILDIGI YERIN yerel gunudur. */}
          <div>
            <label style={S.label}>Location</label>
            <LocationPicker kural="city" value={loc} locations={locations} zorunlu
                            onChange={setLoc} onAdd={addLocation} />
          </div>

          <div>
            <label style={S.label}>Issued by</label>
            <HarfliGiris style={S.input} value={issuedBy} onChange={setIssuedBy}
                   placeholder="E.G. GOZEN AIR TRAINING ORG." />
          </div>

          {/* Esik ARTIK GIRILMEZ, gosterilir. Serbest metin kutusu 19 Agu'da
              kaldirildi: "60,30" yazilirsa CRITICAL hic olusmuyor, bitise 1 gun
              kala bile uyari amber kaliyordu. Serkan: "ayni kalsin, degismesin."
              Sayilar ve renkler TrainingRules'tan basilir — ekranda gorunen ile
              hesabin kullandigi ayrisamaz (Ilke 3). */}
          <div>
            <label style={S.label}>Alerts <span style={{ color:C.t3 }}>— fixed</span></label>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
              {[['NOTICE', `${ALERT_DAYS.NOTICE}\u2013${ALERT_DAYS.WARNING} D`],
                ['WARNING', `${ALERT_DAYS.WARNING}\u2013${ALERT_DAYS.CRITICAL} D`],
                ['CRITICAL', `${ALERT_DAYS.CRITICAL}\u20130 D`],
                ['EXPIRED', 'EXPIRED']].map(([st, txt]) => (
                <span key={st} style={{ padding:'2px 9px', fontSize:9, letterSpacing:1,
                                        fontWeight:700, fontFamily:'var(--mono)',
                                        border:`1px solid ${STATE_COLOR[st]}`, color:STATE_COLOR[st] }}>
                  {txt}
                </span>
              ))}
            </div>
          </div>

          <div>
            <label style={S.label}>Notes</label>
            <HarfliGiris style={S.input} value={notes} onChange={setNotes}
                   placeholder="E.G. EXTENSION APPLIED" />
            <div style={{ marginTop:5, fontSize:9.5, color:C.t3, fontFamily:'var(--mono)' }}>
              ⚠ operational note only — do not enter health information
            </div>
          </div>

          <div>
            <label style={S.label}>
              Reason {editing ? <span style={{ color:C.red }}>— required</span> : <span style={{ color:C.t3 }}>— optional</span>}
            </label>
            <HarfliGiris {...zAlan(S.input, !!editing, gerekceTamam(reason))} data-testid="egitim-gerekce" value={reason} onChange={setReason}
                   placeholder={editing ? 'E.G. DATE MISTYPED, CORRECTED FROM CERTIFICATE' : ''} />
            {editing && <GerekceIpucu metin={reason} testid="egitim-gerekce-ipucu" />}
          </div>

          {locEksik && (
            <div style={{ fontSize:10, color:C.red, fontFamily:'var(--mono)', lineHeight:1.6 }}>
              {locEksik} is required — the record cannot be saved without it.
              A certificate date is the LOCAL date where the training took place.
            </div>
          )}

          <div style={{ display:'flex', justifyContent:'flex-end', gap:10 }}>
            <button style={{ ...dugmeStili('silme'), marginRight:'auto' }} onClick={sifirla} disabled={saving}
                    data-testid="egitim-reset" title="Clear every entry — the window returns to how it opened">RESET</button>
            <button style={S.btnS} onClick={onClose}>CANCEL</button>
            <button style={S.btnP} onClick={save} disabled={saving || !!locEksik}
                    title={locEksik ? `${locEksik} is required` : undefined}>
              {saving ? 'SAVING...' : editing ? 'SAVE CORRECTION' : (prev ? 'RENEW' : 'SAVE')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
